var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffed00;\n      }\n\n      .cls-2 {\n        fill: #00529f;\n        fill-rule: evenodd;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.5,
    cy: 39.5,
    r: 39.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forme_1",
    "data-name": "Forme 1",
    className: "cls-2",
    d: "M45.585,18.988H42.242a4.4,4.4,0,0,0-3.431,1.65L31.333,29.99H21.392a4.4,4.4,0,0,0-4.4,4.4v13.2a4.4,4.4,0,0,0,4.4,4.4h9.941l7.478,9.352A4.4,4.4,0,0,0,42.242,63h3.343a4.4,4.4,0,0,0,4.4-4.4V23.389A4.4,4.4,0,0,0,45.585,18.988ZM56.714,30.342a2.2,2.2,0,0,0-3.189,3.037,11.006,11.006,0,0,1,0,15.205,2.2,2.2,0,1,0,3.189,3.037A15.409,15.409,0,0,0,56.714,30.342Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteFull);
export default __webpack_public_path__ + "static/media/muteFull.85092779.svg";
export { ForwardRef as ReactComponent };